var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('service-synopsis',{key:_vm.view,attrs:{"view":_vm.view,"panels":_vm.panels,"service-garden":_vm.serviceGarden}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }